import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export const getAllProviderCertificate = async (
  id: string,
  pageArg: number,
  limitArg: number
) => {
  try {
    const params = new URLSearchParams({
      businessId: id.toString(),
      page: pageArg.toString(),
      limit: limitArg.toString(),
      isShowProfile: 'true',
    });

    const res = await apiClient.get(
      import.meta.env.VITE_APP_BACKEND_USER + Path.certificate,
      { params }
    );
    return res.data;
  } catch (error: unknown) {
    console.error('Error get all certificate: ', error);
    throw error;
  }
};
